import { render, staticRenderFns } from "./schoolmanager.vue?vue&type=template&id=aa6884f0&scoped=true&"
import script from "./schoolmanager.vue?vue&type=script&lang=js&"
export * from "./schoolmanager.vue?vue&type=script&lang=js&"
import style0 from "./schoolmanager.vue?vue&type=style&index=0&id=aa6884f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6884f0",
  null
  
)

export default component.exports